'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var platform = require('./platform');

var UINT_MAX = 4294967296;
var zeroId = new Uint8Array(8); // Cryptographically secure local seeds to mitigate Math.random() seed reuse.

var seed = new Uint32Array(2);

if (platform.crypto) {
  platform.crypto.getRandomValues(seed);
}

var map = Array.prototype.map;

var pad = function pad(byte) {
  return "".concat(byte < 16 ? '0' : '').concat(byte.toString(16));
}; // Internal representation of a trace or span ID.


var Identifier =
/*#__PURE__*/
function () {
  function Identifier(value, radix) {
    _classCallCheck(this, Identifier);

    this._isUint64BE = true; // msgpack-lite compatibility

    this._buffer = typeof radix === 'number' ? fromString(value, radix) : createBuffer(value);
  }

  _createClass(Identifier, [{
    key: "toString",
    value: function toString(radix) {
      return typeof radix === 'number' ? toNumberString(this._buffer, radix) : toHexString(this._buffer);
    }
  }, {
    key: "toBuffer",
    value: function toBuffer() {
      return this._buffer;
    } // msgpack-lite compatibility

  }, {
    key: "toArray",
    value: function toArray() {
      return this._buffer.subarray(-8);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toString();
    }
  }]);

  return Identifier;
}(); // Create a buffer, using an optional hexadecimal value if provided.


function createBuffer(value) {
  if (value === '0') return zeroId;
  if (!value) return pseudoRandom();
  var size = Math.ceil(value.length / 2);
  var buffer = new Uint8Array(size);

  for (var i = 0; i < size; i++) {
    buffer[i] = parseInt(value.substring(i * 2, i * 2 + 2), 16);
  }

  return buffer;
} // Convert a numerical string to a buffer using the specified radix.


function fromString(str, raddix) {
  var buffer = new Uint8Array(8);
  var len = str.length;
  var pos = 0;
  var high = 0;
  var low = 0;
  if (str[0] === '-') pos++;
  var sign = pos;

  while (pos < len) {
    var chr = parseInt(str[pos++], raddix);
    if (!(chr >= 0)) break; // NaN

    low = low * raddix + chr;
    high = high * raddix + Math.floor(low / UINT_MAX);
    low %= UINT_MAX;
  }

  if (sign) {
    high = ~high;

    if (low) {
      low = UINT_MAX - low;
    } else {
      high++;
    }
  }

  writeUInt32BE(buffer, high, 0);
  writeUInt32BE(buffer, low, 4);
  return buffer;
} // Convert a buffer to a numerical string.


function toNumberString(buffer, radix) {
  var high = readInt32(buffer, 0);
  var low = readInt32(buffer, 4);
  var str = '';
  radix = radix || 10;

  while (1) {
    var mod = high % radix * UINT_MAX + low;
    high = Math.floor(high / radix);
    low = Math.floor(mod / radix);
    str = (mod % radix).toString(radix) + str;
    if (!high && !low) break;
  }

  return str;
} // Convert a buffer to a hexadecimal string.


function toHexString(buffer) {
  return map.call(buffer, pad).join('');
} // Simple pseudo-random 64-bit ID generator.


function pseudoRandom() {
  var buffer = new Uint8Array(8);
  var hi = randomUInt32(seed[0]) & 0x7FFFFFFF; // only positive int64

  var lo = randomUInt32(seed[1]);
  writeUInt32BE(buffer, hi, 0);
  writeUInt32BE(buffer, lo, 4);
  return buffer;
} // Generate a random unsigned 32-bit integer.


function randomUInt32(seed) {
  return seed ^ Math.floor(Math.random() * (0xFFFFFFFF + 1));
} // Read a buffer to unsigned integer bytes.


function readInt32(buffer, offset) {
  return buffer[offset + 0] * 16777216 + (buffer[offset + 1] << 16) + (buffer[offset + 2] << 8) + buffer[offset + 3];
} // Write unsigned integer bytes to a buffer.


function writeUInt32BE(buffer, value, offset) {
  buffer[3 + offset] = value & 255;
  value = value >> 8;
  buffer[2 + offset] = value & 255;
  value = value >> 8;
  buffer[1 + offset] = value & 255;
  value = value >> 8;
  buffer[0 + offset] = value & 255;
}

module.exports = function (value, radix) {
  return new Identifier(value, radix);
};